export default "__VITE_PUBLIC_ASSET__2abff51d__"